export interface InventoryItem {
	id: number;
	statusId: number;
	status: string;
	originalStatus: number;
	categoryId: number;
	categoryDesc: string;
	equipId: number;
	equipName: string;
	attributes: InventoryAttribute[];
	customerServiceId: number;
	customerServiceDescription: string;
}

export interface InventoryAttribute {
	id: number;
	name?: string;
	value: string;
}

export interface InventoryStatus {
	id: number;
	status: string;
	isDefaultActiveStatus?: boolean;
	isDefaultRemovedStatus?: boolean;
	isForOnDemandEquipment?: boolean;
	isForEquipmentToBeRemoved?: boolean;
	isForActiveEquipment?: boolean;
	inventoryAvailable?: boolean;
}

export interface InventoryRemovalReason {
	id: number;
	description: string;
}

export interface InventoryRemovalUpdate {
	reasonId?: number;
	statusId: number;
	note?: string;
}

export enum TruckInventoryIdCode {
	ALL = 0,
	AVAILABLE = 3,
}

export interface TruckInventoryFilters {
	categoryId: number;
	equipmentId: number;
	statusId: number;
}
